import { Box, Button, Dialog, DialogContent, DialogTitle, FormControl, FormGroup, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import useOptions from "../../../hooks/useOptions";
import { ApiResponseType } from "../../../types";
import CadenceTypeDropdown from "../../common2/Dropdowns/CadenceTypeDropdown";
import { PlaybookCadence, PlaybookStore } from "../PlaybookStore";
import CloseIcon from '@mui/icons-material/Close';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SimpleDialog from "../../common/SimpleDialog";
import SectionAppBar from "../../../v2/components/Section/SectionAppBar";
import SaveButton from "../../../v2/components/Button/SaveButton";
import StandardButton from "../../../v2/components/Button/StandardButton";

type Props<T> = {
    open: boolean,
    onClose: () => void,
    onSubmit: (data: T) => Promise<ApiResponseType>,
    title: string,
    subTitle: string,
    fieldLabel: string,
    confirmButtonLabel: string,
    record: T
}

const EditCadence = <T extends PlaybookCadence>({ open, onClose, onSubmit, title, subTitle, fieldLabel, confirmButtonLabel, record }: Props<T>) => {
    const { options: stages } = useOptions("stage");
    const { options: actions } = useOptions("cadenceaction");
    const [showNextCadence, setShowNextCadence] = useState(false);
    const playbook = PlaybookStore.useState(s => s.selectedPlaybook);

    const {
        control,
        setValue,
        handleSubmit,
        setError,
        getValues,
        formState: { errors }
    } = useForm({ defaultValues: { name: '', endActionId: '', templateId: '', endStageId: '', startStageId: '', cadenceTypeId: '', cadenceTemplateId: '', nextCadenceId: null as null | string } })

    useEffect(() => {
        setValue('name', record.name);
        //setValue('activeEndDate', record.activeEndDate);
        //setValue('activeStartDate', record.activeStartDate);
        setValue('endStageId', record.endStageId);
        setValue('startStageId', record.startStageId);
        setValue('endActionId', record.endActionId);
        setValue('cadenceTypeId', record.cadenceTypeId)
        setValue('nextCadenceId', record.nextCadenceId)
        
        if (record.endActionId && record.endActionId.toUpperCase() === "6A0CCC39-E9BE-4B8B-A6FC-82AED2F1C75E") {
            setShowNextCadence(true);
        } else {
            setShowNextCadence(false);
        }
        //setValue('templateId', record.templateId);        
    }, [record])

    const onSaveRecord = async (data: any) => {
        const response = await onSubmit({ ...record, ...data, playbookId: playbook?.id });

        if (response.succeeded) {
            setValue('name', '');
            onClose();
        } else {
            setError('name', { message: response.errors[0].description });
        }
    }


    return (
        <SimpleDialog
            open={open}
            onClose={onClose}
            padding={0}
            fullHeight={false}
            size='md'
        >
            <SectionAppBar
                title={title}
                subTitle={subTitle}
                buttons={
                    <>
                        <SaveButton size='small' type='submit' variant='contained' onClick={handleSubmit(onSaveRecord)} icon={<SaveAltIcon />}>
                            Save
                        </SaveButton>
                        <StandardButton size='small' variant='outlined' color='secondary' onClick={onClose} icon={<CloseIcon />}>
                            Cancel
                        </StandardButton>
                    </>
                }
            />            
            <DialogContent sx={{ pb: 12, mx: 'auto' }}>
                <Box component='form' sx={{ mt: 4 }} onSubmit={handleSubmit(onSaveRecord)}>
                    <Grid container spacing={2} rowGap={2}>
                        {/*<Grid item xs={12}>*/}
                        {/*    <FormGroup sx={{ mb: 1 }}>*/}
                        {/*        <FormControl size="small">*/}
                        {/*            <InputLabel>Template Type</InputLabel>*/}
                        {/*            <Controller*/}
                        {/*                name='templateId'*/}
                        {/*                control={control}*/}
                        {/*                rules={{ required: true }}*/}
                        {/*                render={({ field: { value, onChange } }) => (*/}
                        {/*                    <Select*/}
                        {/*                        size="small"*/}
                        {/*                        value={value}*/}
                        {/*                        label='Template Type'*/}
                        {/*                        onChange={onChange}*/}
                        {/*                        error={Boolean(errors.templateId)}*/}
                        {/*                    >*/}
                        {/*                        <MenuItem value=''>Please select</MenuItem>*/}
                        {/*                        {playbook?.templates.map(option => <MenuItem value={option.id}>{option.name} ({option.templateType})</MenuItem>)}*/}
                        {/*                    </Select>*/}
                        {/*                )}*/}
                        {/*            />*/}
                        {/*        </FormControl>*/}
                        {/*        {errors.templateId && (*/}
                        {/*            <FormHelperText sx={{ color: 'error.main' }}>{errors.templateId.message ? errors.templateId.message : <>Please enter a valid template type</>}</FormHelperText>*/}
                        {/*        )}*/}
                        {/*    </FormGroup>*/}
                        {/*</Grid>*/}
                        <Grid item xs={12}>
                            <FormGroup sx={{ mb: 1 }}>
                                <Controller
                                    name='name'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            size="small"
                                            fullWidth
                                            value={value}
                                            label='Name'
                                            onChange={onChange}
                                            error={Boolean(errors.name)}
                                            placeholder={`Enter ${fieldLabel}`}
                                        />
                                    )}
                                />
                                {errors.name && (
                                    <FormHelperText sx={{ color: 'error.main' }}>{errors.name.message ? errors.name.message : <>Please enter a valid {fieldLabel.toLowerCase()}</>}</FormHelperText>
                                )}
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12}>
                            <FormGroup sx={{ mb: 1 }}>
                                <FormControl size="small">
                                    <InputLabel>Cadence Type</InputLabel>
                                    <Controller
                                        name='cadenceTypeId'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <CadenceTypeDropdown value={value} onChange={(newValue: string) => onChange(newValue)} />
                                        )}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        {/*<Grid item xs={12}>*/}
                        {/*    <FormGroup sx={{ mb: 1 }}>*/}
                        {/*        <Controller*/}
                        {/*            name='isActive'*/}
                        {/*            control={control}*/}
                        {/*            rules={{ required: false }}*/}
                        {/*            render={({ field: { value, onChange } }) => (*/}
                        {/*                <FormControl fullWidth size="small">*/}
                        {/*                    <InputLabel id='status-label'>Status</InputLabel>*/}
                        {/*                    <Select*/}
                        {/*                        label='Status'*/}
                        {/*                        defaultValue={value ? "active" : "inactive"}*/}
                        {/*                        value={value ? "active" : "inactive"}*/}
                        {/*                        id='view-status'*/}
                        {/*                        labelId='status-label'*/}
                        {/*                        onChange={(e) => onChange(e.target.value === "active")}*/}
                        {/*                    >*/}
                        {/*                        <MenuItem value='active'>Active</MenuItem>*/}
                        {/*                        <MenuItem value='inactive'>Inactive</MenuItem>*/}
                        {/*                    </Select>*/}
                        {/*                </FormControl>*/}
                        {/*            )}*/}
                        {/*        />*/}
                        {/*    </FormGroup>*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={6}>*/}
                        {/*    <FormGroup sx={{ mb: 1 }}>*/}
                        {/*        <Controller*/}
                        {/*            name='activeStartDate'*/}
                        {/*            control={control}*/}
                        {/*            rules={{ required: true }}*/}
                        {/*            render={({ field: { value, onChange } }) => (*/}
                        {/*                <CustomDatePicker*/}
                        {/*                    value={value}*/}
                        {/*                    label='Active Start Date'*/}
                        {/*                    onChange={onChange}*/}
                        {/*                    error={Boolean(errors.activeStartDate)}*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*        />*/}
                        {/*        {errors.activeStartDate && (*/}
                        {/*            <FormHelperText sx={{ color: 'error.main' }}>{errors.activeStartDate.message ? errors.activeStartDate.message : <>Please enter a valid active start date</>}</FormHelperText>*/}
                        {/*        )}*/}
                        {/*    </FormGroup>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={6}>*/}
                        {/*    <FormGroup sx={{ mb: 1 }}>*/}
                        {/*        <Controller*/}
                        {/*            name='activeEndDate'*/}
                        {/*            control={control}*/}
                        {/*            rules={{ required: true }}*/}
                        {/*            render={({ field: { value, onChange } }) => (*/}
                        {/*                <CustomDatePicker*/}
                        {/*                    value={value}*/}
                        {/*                    label='Active End Date'*/}
                        {/*                    onChange={onChange}*/}
                        {/*                    error={Boolean(errors.activeEndDate)}*/}
                        {/*                />*/}
                        {/*            )}*/}
                        {/*        />*/}
                        {/*        {errors.activeEndDate && (*/}
                        {/*            <FormHelperText sx={{ color: 'error.main' }}>{errors.activeEndDate.message ? errors.activeEndDate.message : <>Please enter a valid active end date</>}</FormHelperText>*/}
                        {/*        )}*/}
                        {/*    </FormGroup>*/}
                        {/*</Grid>*/}
                        <Grid item xs={6}>
                            <FormGroup sx={{ mb: 1 }}>
                                <FormControl size="small">
                                    <InputLabel>Start Stage</InputLabel>
                                    <Controller
                                        name='startStageId'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                value={value}
                                                onChange={onChange}
                                                label="Start Stage"
                                                error={Boolean(errors.startStageId)}
                                            >
                                                <MenuItem value=''>Please select</MenuItem>
                                                {stages.map(option => <MenuItem value={option.value}>{option.name}</MenuItem>)}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors.startStageId && (
                                    <FormHelperText sx={{ color: 'error.main' }}>{errors.startStageId.message ? errors.startStageId.message : <>Please enter a valid start stage</>}</FormHelperText>
                                )}
                            </FormGroup>
                        </Grid>
                        <Grid item xs={6}>
                            <FormGroup sx={{ mb: 1 }}>
                                <FormControl size="small">
                                    <InputLabel>End Stage</InputLabel>
                                    <Controller
                                        name='endStageId'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                value={value}
                                                label='End Stage'
                                                onChange={onChange}
                                                error={Boolean(errors.endStageId)}
                                            >
                                                <MenuItem value=''>Please select</MenuItem>
                                                {stages.map(option => <MenuItem value={option.value}>{option.name}</MenuItem>)}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors.endStageId && (
                                    <FormHelperText sx={{ color: 'error.main' }}>{errors.endStageId.message ? errors.endStageId.message : <>Please enter a valid end stage</>}</FormHelperText>
                                )}
                            </FormGroup>
                        </Grid>
                        <Grid item xs={6}>
                            <FormGroup sx={{ mb: 1 }}>
                                <FormControl size="small">
                                    <InputLabel>End Action</InputLabel>
                                    <Controller
                                        name='endActionId'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                value={value}
                                                label='End Action'
                                                onChange={(newValue) => { onChange(newValue); setShowNextCadence(newValue.target.value.toUpperCase() === '6A0CCC39-E9BE-4B8B-A6FC-82AED2F1C75E') }}
                                                error={Boolean(errors.endActionId)}
                                            >
                                                <MenuItem value=''>Please select</MenuItem>
                                                {actions.map(option => <MenuItem value={option.value}>{option.name}</MenuItem>)}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors.endActionId && (
                                    <FormHelperText sx={{ color: 'error.main' }}>{errors.endActionId.message ? errors.endActionId.message : <>Please enter a valid end action</>}</FormHelperText>
                                )}
                            </FormGroup>
                        </Grid>
                        {showNextCadence && <Grid item xs={6}>
                            <FormGroup sx={{ mb: 1 }}>
                                <FormControl size="small">
                                    <InputLabel>Next Cadence</InputLabel>
                                    <Controller
                                        name='nextCadenceId'
                                        control={control}                                        
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                value={value}
                                                label='Next Cadence'
                                                onChange={onChange}
                                                error={Boolean(errors.nextCadenceId)}
                                            >
                                                <MenuItem value=''>Please select</MenuItem>
                                                {playbook?.cadences.map(option => <MenuItem value={option.id}>{option.name}</MenuItem>)}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors.nextCadenceId && (
                                    <FormHelperText sx={{ color: 'error.main' }}>{errors.nextCadenceId.message ? errors.nextCadenceId.message : <>Please enter a valid next cadence</>}</FormHelperText>
                                )}
                            </FormGroup>
                        </Grid>}
                    </Grid>
                </Box>
            </DialogContent>
        </SimpleDialog>

    )
}

export { EditCadence }
export default EditCadence;